import {
    FETCH_REPAIRERS_REQUEST,
    FETCH_REPAIRERS_SUCCESS,
    FETCH_REPAIRERS_FAILURE, FILTER_REPAIRERS_REQUEST, FILTER_REPAIRERS_SUCCESS, FILTER_REPAIRERS_FAILURE,
} from '../action/repairer';

const initialState = {
    loading: false,
    repairers: [],
    filteredRepairers: [],
    error: null,
};

const repairerReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_REPAIRERS_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case FETCH_REPAIRERS_SUCCESS:
            return {
                ...state,
                loading: false,
                repairers: action.payload,
            };
        case FETCH_REPAIRERS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        case FILTER_REPAIRERS_REQUEST:
            return {
                ...state,
                loading: true,
                //error: null,
            };
        case FILTER_REPAIRERS_SUCCESS:
            return {
                ...state,
                loading: false,
                filteredRepairers: action.payload,
                error: null,
            };
        case FILTER_REPAIRERS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        default:
            return state;
    }
};

export default repairerReducer;
